export const USA = 233;
export const CANADA = 38;

export const TZ_OFFSET = new Date().getTimezoneOffset();
export const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
